import { Box, Typography } from "@mui/material";

import LogoSivina from "../assets/images/bg/logo.png";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{ bgcolor: "#f8f8f8", borderTop: "1px solid #e0e0e0" }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: 3,
          py: 2,
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", color: "#00aaff", fontSize: 24, textAlign: "center", mt: 2}}>
          <img src={LogoSivina} alt="Logo Sivina" width={"40rem"} />
        </Typography>

        <Typography sx={{ fontWeight: "bold", color: "#2F2F2F", fontSize: 20, textAlign: "center", mt: 2}}>
          Application For Retail Audit and Observation Survey.
        </Typography>
      </Box>

      <Box sx={{ bgcolor: "#2F2F2F", py: 1 }}>
        <Typography variant="body2" align="center" sx={{ color: "#fff" }}>
          All Rights Reserved &#174; 2023 - 2025 PT Exorty Indonesia
        </Typography>
      </Box>
    </Box>
  );
}
